
(function() {
  var desktopNavInstances = Array.prototype.slice.call(document.querySelectorAll('.ichika-desktop-support-nav'));
  desktopNavInstances.slice(0, -1).forEach(function(nav) {
    nav.remove();
  });
  var navInstances = Array.prototype.slice.call(document.querySelectorAll('.ichika-mobile-bottom-nav'));
  navInstances.slice(0, -1).forEach(function(nav) {
    nav.remove();
  });
  var scrollTopInstances = Array.prototype.slice.call(document.querySelectorAll('.ichika-scroll-top'));
  scrollTopInstances.slice(0, -1).forEach(function(button) {
    button.remove();
  });

  function isMobile() {
    return window.matchMedia('(max-width: 767px)').matches;
  }

  function clickFirst(selectors) {
    for (var i = 0; i < selectors.length; i += 1) {
      var element = document.querySelector(selectors[i]);
      if (element && !element.closest('.ichika-mobile-bottom-nav, .ichika-desktop-support-nav')) {
        element.click();
        return true;
      }
    }
    return false;
  }

  function isCollectionListing() {
    return /^\/collections\/[^/]+/.test(window.location.pathname) || Boolean(document.querySelector('.ichika-filter-cta, .cloud-search-page-controls__filters-link'));
  }

  function configurePrimaryItem() {
    var item = document.querySelector('[data-ichika-mobile-action="primary"]');
    if (!item) return;
    var label = item.querySelector('[data-ichika-primary-label]');
    var filterIcon = item.querySelector('.ichika-mobile-bottom-nav__primary-filter');
    var searchIcon = item.querySelector('.ichika-mobile-bottom-nav__primary-search');
    var listing = isCollectionListing();
    item.setAttribute('aria-label', listing ? '絞り込む' : '検索');
    if (label) label.textContent = listing ? '絞り込む' : '検索';
    if (filterIcon) {
      filterIcon.toggleAttribute('hidden', !listing);
      filterIcon.style.display = listing ? 'block' : 'none';
    }
    if (searchIcon) {
      searchIcon.toggleAttribute('hidden', listing);
      searchIcon.style.display = listing ? 'none' : 'block';
    }
  }

  function openFilter() {
    if (clickFirst(['.ichika-filter-cta', '.cloud-search-page-controls__filters-link'])) {
      return;
    }
    openSearchPanel();
  }

  function openSearchPanel() {
    if (clickFirst([
      'header a[aria-label="検索を開く"]',
      'header button[aria-label="検索を開く"]',
      'header a[href="/search"]',
      'header button[aria-controls*="search" i]'
    ])) return;
    window.location.href = '/search';
  }

  var viewportUpdateFrame = 0;

  function updateViewportInsets() {
    var topInset = 0;
    var bottomInset = 0;
    var viewport = window.visualViewport;
    if (isMobile() && viewport) {
      topInset = Math.max(0, Math.round(viewport.offsetTop));
      bottomInset = Math.max(0, Math.round(window.innerHeight - viewport.height - viewport.offsetTop));
      if (topInset < 2) topInset = 0;
      if (bottomInset < 2) bottomInset = 0;
    }
    document.documentElement.style.setProperty('--ichika-visual-viewport-top', topInset + 'px');
    document.documentElement.style.setProperty('--ichika-visual-viewport-bottom', bottomInset + 'px');
  }

  function scheduleViewportUpdate() {
    if (viewportUpdateFrame) window.cancelAnimationFrame(viewportUpdateFrame);
    viewportUpdateFrame = window.requestAnimationFrame(function() {
      viewportUpdateFrame = 0;
      updateViewportInsets();
      updateProductCtaOffset();
    });
  }

  function updateProductCtaOffset() {
    var offset = 0;
    if (isMobile() && /^\/products\//.test(window.location.pathname)) {
      var viewportHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;
      var selectors = [
        'button[name="add"]',
        'button[type="submit"][name="add"]',
        '.product-form__add-button',
        '[data-product-add-to-cart]',
        '.product-sticky-bar button[type="submit"]',
        'product-sticky-bar button[type="submit"]'
      ];
      document.querySelectorAll(selectors.join(',')).forEach(function(button) {
        if (button.closest('.ichika-mobile-bottom-nav, shopify-chat')) return;
        var buttonStyle = window.getComputedStyle(button);
        if (buttonStyle.display === 'none' || buttonStyle.visibility === 'hidden' || Number(buttonStyle.opacity) === 0) return;
        var positioned = button;
        var node = button;
        while (node && node !== document.body) {
          var nodeStyle = window.getComputedStyle(node);
          if (nodeStyle.position === 'fixed' || nodeStyle.position === 'sticky') {
            positioned = node;
            break;
          }
          node = node.parentElement;
        }
        if (positioned === button && buttonStyle.position !== 'fixed' && buttonStyle.position !== 'sticky') return;
        var rect = positioned.getBoundingClientRect();
        var height = Math.ceil(viewportHeight - rect.top + 8);
        var visible = rect.width > 120 && rect.height > 36 && rect.top >= 0 && rect.top < viewportHeight && rect.bottom > viewportHeight - 220;
        if (visible && height > 0 && height <= 220) {
          offset = Math.max(offset, height);
        }
      });
    }
    document.documentElement.style.setProperty('--ichika-product-cta-offset', offset + 'px');
  }

  function openWishlist() {
    var nativeWishlist = findInOpenShadowRoots(document, 'button[aria-label*="Open ウィッシュリスト"], button[aria-label*="Open wishlist" i]');
    if (nativeWishlist) {
      nativeWishlist.click();
      if (window.IchikaActionDrawers) window.IchikaActionDrawers.track('wishlist');
      return;
    }
    if (clickFirst(['body > [aria-label*="ウィッシュリスト"]', '[aria-label*="Open ウィッシュリスト"]', '[aria-label*="wishlist" i]'])) {
      return;
    }
    if (window.IchikaActionDrawers && window.IchikaActionDrawers.open('wishlist')) return;
    window.location.href = '/pages/wishlist';
  }

  function openReviews() {
    if (window.IchikaActionDrawers && window.IchikaActionDrawers.open('reviews')) return;
    window.location.href = '/pages/reviews';
  }

  function findInOpenShadowRoots(root, selector) {
    if (!root) return null;
    var directMatch = root.querySelector(selector);
    if (directMatch) return directMatch;
    var elements = root.querySelectorAll('*');
    for (var i = 0; i < elements.length; i += 1) {
      if (!elements[i].shadowRoot) continue;
      var nestedMatch = findInOpenShadowRoots(elements[i].shadowRoot, selector);
      if (nestedMatch) return nestedMatch;
    }
    return null;
  }

  function openChat() {
    if (window.IchikaActionDrawers) window.IchikaActionDrawers.track('consult');
    var shopifyChat = document.querySelector('shopify-chat, shopify-inbox');
    if (shopifyChat) {
      shopifyChat.style.removeProperty('display');
      shopifyChat.style.removeProperty('opacity');
      shopifyChat.style.removeProperty('pointer-events');
      shopifyChat.style.removeProperty('transform');
      shopifyChat.setAttribute('open', '');
      var agentRuntime = shopifyChat.shadowRoot && shopifyChat.shadowRoot.querySelector('shopify-agent-runtime');
      if (agentRuntime) agentRuntime.setAttribute('open', '');
      window.requestAnimationFrame(hideInboxActivator);
      return;
    }
    if (clickFirst(['[aria-label*="チャット"]', '[aria-label*="chat" i]', '[class*="chat" i] button', '[class*="inbox" i] button'])) {
      return;
    }
    window.location.href = '/pages/contact';
  }

  var inboxRoot = null;
  var inboxObserver = null;

  function observeInboxRoot(root) {
    if (!root || root === inboxRoot) return;
    if (inboxObserver) inboxObserver.disconnect();
    inboxRoot = root;
    inboxObserver = new MutationObserver(function() {
      window.requestAnimationFrame(hideInboxActivator);
    });
    inboxObserver.observe(root, { childList: true, subtree: true });
  }

  function hideInboxActivator() {
    var shopifyChat = document.querySelector('shopify-chat, shopify-inbox');
    if (!shopifyChat || !shopifyChat.shadowRoot) return;
    var activator = findInOpenShadowRoots(shopifyChat.shadowRoot, '[part~="activator"], button.activator, button[aria-label="チャットを開く"], button[aria-label="Open chat"]');
    var guardRoot = activator && activator.getRootNode ? activator.getRootNode() : shopifyChat.shadowRoot;
    observeInboxRoot(guardRoot);
    var guardStyle = guardRoot.querySelector('[data-ichika-inbox-guard]');
    if (!guardStyle) {
      guardStyle = document.createElement('style');
      guardStyle.setAttribute('data-ichika-inbox-guard', '');
      guardStyle.textContent = '.activator-nudge, [part~="activator"], button.activator, button[aria-label="チャットを開く"], button[aria-label="Open chat"] { opacity: 0 !important; pointer-events: none !important; transform: translateY(16px) !important; }';
      guardRoot.appendChild(guardStyle);
    }
    if (!activator) return;
    activator.style.setProperty('opacity', '0', 'important');
    activator.style.setProperty('pointer-events', 'none', 'important');
    activator.style.setProperty('transform', 'translateY(16px)', 'important');
    var nudge = activator.closest('.activator-nudge');
    if (nudge) {
      nudge.style.setProperty('opacity', '0', 'important');
      nudge.style.setProperty('pointer-events', 'none', 'important');
      nudge.style.setProperty('transform', 'translateY(16px)', 'important');
    }
  }

  function setActive(action) {
    document.querySelectorAll('.ichika-mobile-bottom-nav__item').forEach(function(item) {
      item.classList.remove('is-active');
    });
  }

  function hideFloatingClutter() {
    if (!isMobile()) return;
    hideInboxActivator();
    document.querySelectorAll('body > a, body > button, body > div, body > iframe, body > shopify-inbox').forEach(function(element) {
      if (element.closest('.ichika-mobile-bottom-nav') || element.classList.contains('ichika-scroll-top')) return;
      if (element.tagName === 'SHOPIFY-CHAT' || element.tagName === 'SHOPIFY-INBOX' || element.querySelector('shopify-chat, shopify-inbox')) return;
      var style = window.getComputedStyle(element);
      if (style.position !== 'fixed') return;
      var rect = element.getBoundingClientRect();
      var label = ((element.innerText || '') + ' ' + (element.getAttribute('aria-label') || '') + ' ' + (element.getAttribute('title') || '')).trim();
      var hasOldTopImage = Boolean(element.querySelector && element.querySelector('img[src*="arrow-top.png"]'));
      var isRightFloating = rect.right > window.innerWidth - 110 && rect.bottom > window.innerHeight - 230;
      var isWidget = /wishlist|ウィッシュリスト|チャット|トップ|上へ/i.test(label + ' ' + element.id + ' ' + element.className);
      var isEmptyButton = !label && rect.width <= 80 && rect.height <= 80;
      if (hasOldTopImage || isRightFloating || isWidget || isEmptyButton) {
        element.style.setProperty('opacity', '0', 'important');
        element.style.setProperty('pointer-events', 'none', 'important');
        element.style.setProperty('transform', 'translateY(16px)', 'important');
        if (hasOldTopImage || isWidget) {
          element.style.setProperty('display', 'none', 'important');
        }
      }
    });
  }

  function updateCartBadge() {
    var badge = document.querySelector('[data-ichika-cart-badge]');
    if (!badge) return;
    var countText = '';
    var countElement = document.querySelector('cart-count, .cart-count, [data-cart-count], .header__cart-count, .cart-drawer__count');
    if (countElement) countText = (countElement.textContent || countElement.getAttribute('data-cart-count') || '').trim();
    var count = parseInt(countText.replace(/[^0-9]/g, ''), 10);
    if (count > 0) {
      badge.textContent = count > 9 ? '9+' : String(count);
      badge.classList.add('is-visible');
    } else {
      badge.textContent = '';
      badge.classList.remove('is-visible');
    }
  }

  if (!document.documentElement.classList.contains('ichika-mobile-bottom-nav-bound-v3')) {
    document.documentElement.classList.add('ichika-mobile-bottom-nav-bound-v3');
    document.addEventListener('click', function(event) {
      var supportItem = event.target.closest('[data-ichika-support-action]');
      var actionItem = event.target.closest('[data-ichika-mobile-action]');
      if (supportItem && !isMobile()) {
        var supportAction = supportItem.getAttribute('data-ichika-support-action');
        event.preventDefault();
        document.querySelectorAll('.ichika-desktop-support-nav__item').forEach(function(item) {
          item.classList.toggle('is-active', item === supportItem);
        });
        if (supportAction === 'wishlist') openWishlist();
        if (supportAction === 'reviews') openReviews();
        if (supportAction === 'chat') openChat();
        return;
      }
      if (!actionItem || !isMobile()) return;
      var action = actionItem.getAttribute('data-ichika-mobile-action');
      event.preventDefault();
      if (action === 'primary') {
        setActive('primary');
        openFilter();
      }
      if (action === 'wishlist') {
        setActive('wishlist');
        openWishlist();
      }
      if (action === 'chat') {
        setActive('chat');
        openChat();
      }
    });
  }

  var scrollTopButton = document.querySelector('.ichika-scroll-top');
  if (scrollTopButton && !scrollTopButton.dataset.ichikaBound) {
    scrollTopButton.dataset.ichikaBound = 'true';
    scrollTopButton.addEventListener('click', function() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
    var updateScrollTopButton = function() {
      scrollTopButton.classList.toggle('is-visible', isMobile() && window.scrollY > 420);
    };
    window.addEventListener('scroll', updateScrollTopButton, { passive: true });
    window.addEventListener('resize', updateScrollTopButton);
    updateScrollTopButton();
    window.setTimeout(updateScrollTopButton, 800);
    window.setTimeout(updateScrollTopButton, 2500);
  }

  configurePrimaryItem();
  window.addEventListener('load', configurePrimaryItem, { once: true });
  window.setTimeout(configurePrimaryItem, 800);

  updateViewportInsets();
  window.addEventListener('scroll', scheduleViewportUpdate, { passive: true });
  window.addEventListener('resize', scheduleViewportUpdate);
  window.addEventListener('orientationchange', scheduleViewportUpdate);
  window.addEventListener('pageshow', scheduleViewportUpdate);
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', scheduleViewportUpdate);
    window.visualViewport.addEventListener('scroll', scheduleViewportUpdate, { passive: true });
  }
  document.addEventListener('visibilitychange', function() {
    if (!document.hidden) scheduleViewportUpdate();
  });
  window.setTimeout(scheduleViewportUpdate, 300);
  window.setTimeout(scheduleViewportUpdate, 1200);

  updateProductCtaOffset();
  window.addEventListener('load', updateProductCtaOffset, { once: true });
  window.setTimeout(updateProductCtaOffset, 800);
  window.setTimeout(updateProductCtaOffset, 2500);

  var floatingUpdateFrame = 0;
  var floatingObserver = new MutationObserver(function() {
    if (floatingUpdateFrame) return;
    floatingUpdateFrame = window.requestAnimationFrame(function() {
      floatingUpdateFrame = 0;
      hideFloatingClutter();
    });
  });
  if (document.body) {
    floatingObserver.observe(document.body, { childList: true });
  }

  hideFloatingClutter();
  window.addEventListener('load', hideFloatingClutter, { once: true });
  window.addEventListener('resize', hideFloatingClutter);
  window.setTimeout(hideFloatingClutter, 800);
  window.setTimeout(hideFloatingClutter, 2500);
  window.setTimeout(hideFloatingClutter, 5000);
  window.setTimeout(hideInboxActivator, 800);
  window.setTimeout(hideInboxActivator, 2500);
  window.setTimeout(hideInboxActivator, 5000);

  updateCartBadge();
  document.addEventListener('cart:refresh', updateCartBadge);
  document.addEventListener('cart:change', updateCartBadge);
  window.addEventListener('load', updateCartBadge, { once: true });
  window.setTimeout(updateCartBadge, 1000);
  window.setTimeout(updateCartBadge, 3000);
})();

document.getElementById('page-top')?.addEventListener('click', function(event) { event.preventDefault(); window.scrollTo({top:0,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'}); });
document.querySelectorAll('.ssw-recommend-author').forEach(function(el){el.textContent='匿名';});

// XCloud renders its mobile search outside Prestige's header-search element.
// Keep keyboard focus within the visible search dialog instead of its underlay.
(function () {
  var search = document.querySelector('header-search');
  if (!search) return;
  var activeDialog = null;
  var dialogObserver = new MutationObserver(syncSearchDialog);
  function syncSearchDialog() {
    var dialog = document.querySelector('.cloud-search-mobile')?.closest('[role="dialog"]');
    if (dialog && search.hasAttribute('open') && dialog !== activeDialog) {
      activeDialog = dialog;
      dialogObserver.observe(dialog, {childList: true, subtree: true});
      search.focusTrap.updateContainerElements(dialog);
    } else if (!dialog && activeDialog) {
      activeDialog = null;
      dialogObserver.disconnect();
      search.focusTrap.updateContainerElements(search);
      search.hide();
    }
  }
  new MutationObserver(syncSearchDialog).observe(document.body, {childList: true});
  search.addEventListener('dialog:after-show', syncSearchDialog);
})();
